import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { EVENT } from 'lib/segment/const'
import { segmentReferralTrack, segmentReferralViewedTrack } from 'lib/segment'
import ReferralHowToEarn from 'components/referral/landing/landing-desktop/how-to-earn'
import ReferralBanner from 'components/referral/landing/landing-desktop/banner'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import { REFERRAL_LOCIZE } from 'components/referral/landing/const'

const ReferralDesktopLandingNonLoyaltyUser = ({
  internationalization: { country, language },
  ref_type,
  t,
}) => {
  useEffect(() => {
    if (ref_type)
      segmentReferralViewedTrack(EVENT.referralInterimViewed, ref_type)
  }, [ref_type])

  return (
    <div className="referral-landing">
      <ReferralBanner>
        <Button
          className="referral-landing-banner__content-button"
          type={BUTTON_TYPES.primary}
          link
          onClick={() =>
            segmentReferralTrack(EVENT.referralPMLPerkSignupClicked)
          }
          aProps={{
            href: `/${country}/${language}/loyalty-program`,
            rel: 'noopener',
          }}
          target="_blank"
        >
          {hasLocizeTranslation(
            t,
            REFERRAL_LOCIZE.REFERRAL_SIGN_UP_PERKS.key,
            REFERRAL_LOCIZE.REFERRAL_SIGN_UP_PERKS.text,
          )}
        </Button>
      </ReferralBanner>
      <ReferralHowToEarn />
    </div>
  )
}

ReferralDesktopLandingNonLoyaltyUser.propTypes = {
  internationalization: PropTypes.shape({
    country: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
  ref_type: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next()(ReferralDesktopLandingNonLoyaltyUser)

export default connect((state) => ({
  internationalization: state.internationalization,
}))(Extended)
